<html>

<head>
    <meta http-equiv='Content-Type' content='text/html;charset=ISO-8859-I'>
    <title>Karexpert</title>
</head>

<body>
    Redirect back to the app<br>
    <!-- <form name='frm' method='post'>
        <input type='hidden' id='success' name='success' [(ngModel)]="success" />
        <input type='hidden' id='referenceId' name='referenceId' [(ngModel)]="referenceId" />
    </form>
    <script type='text/javascript'>
        function response() {
            return document.getElementById('response').value;
        }
    </script> -->
</body>

</html>